<template>
  <!-- 生成人群包 -->
  <y-dialog
    title="生成人群包"
    :visible="isShowDialog"
    width="520px"
    :before-close="cancelBtn"
    :sure-loading="loading"
    @comfirm="sureBtn"
    @close="cancelBtn"
  >
    <y-tip style="margin: 0 0 20px 0">
      <div>
        生成的人群保存至云雀【客户管理-客户分群-人群列表】栏目列表，且人群类型为：导入人群
      </div>
    </y-tip>
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="90px"
      size="small"
    >
      <el-form-item label="人群名称：" prop="name">
        <el-input
          v-model="form.name"
          placeholder="请输入人群名称"
          maxlength="32"
          show-word-limit
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="人群描述：" prop="description">
        <el-input
          v-model="form.description"
          placeholder="请输入人群描述"
          maxlength="50"
          show-word-limit
          clearable
        ></el-input>
      </el-form-item>
    </el-form>
  </y-dialog>
</template>

<script>
export default {
  props: {
    isShowDialog: {
      type: Boolean,
      default: false,
    },
    // 父级传入的默认名称/描述，不传则用「积分即将过期会员 + 当前时间」
    defaultName: {
      type: String,
      default: "",
    },
    defaultDescription: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        name: "",
        description: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入人群名称", trigger: "blur" },
        ],
        description: [
          { required: true, message: "请输入人群描述", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.initForm();
  },
  methods: {
    // 默认名称：积分即将过期会员 2026-10-22 17:03:19
    defaultText() {
      const pad = (n) => (n < 10 ? "0" + n : "" + n);
      const d = new Date();
      return `积分即将过期会员 ${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate()
      )} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    initForm() {
      const text = this.defaultText();
      this.form.name = this.defaultName || text;
      this.form.description = this.defaultDescription || text;
    },
    // 确定
    sureBtn() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.$emit("comfirm", {
          crowdName: this.form.name.trim(),
          crowdDescription: this.form.description.trim(),
        });
      });
    },
    // 取消
    cancelBtn() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
